import { useEffect, useState } from "react";

const navLinks = [
  { href: "#top", label: "首页" },
  { href: "#live", label: "实时动态" },
  { href: "#schedule", label: "赛程安排" },
  { href: "#report", label: "晋级战报" },
  { href: "#bracket", label: "晋级名单" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 shadow-[0_6px_30px_-18px_rgba(0,0,0,0.4)] backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a href="#top" className="group flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
            <i className="ri-emotion-laugh-line text-lg" aria-hidden="true"></i>
            <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full border-2 border-background-50 bg-accent-500"></span>
          </span>
          <span className="font-heading text-xl leading-none tracking-tight text-foreground-950">
            吃瓜大赛
          </span>
          <span className="hidden rounded-full bg-secondary-500 px-2 py-0.5 text-[10px] font-bold leading-none text-background-50 sm:inline-block">
            S07
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#schedule"
            className="ml-2 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-fill text-sm" aria-hidden="true"></i>
            追最新赛况
          </a>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="mx-3 mb-3 rounded-2xl border border-background-200 bg-background-50 p-2 shadow-xl md:hidden">
          <div className="grid gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#schedule"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50"
            >
              <i className="ri-play-fill text-sm" aria-hidden="true"></i>
              追最新赛况
            </a>
          </div>
        </div>
      )}
    </header>
  );
}